import script from "./SectionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionList.vue?vue&type=script&setup=true&lang=ts"

import "./SectionList.vue?vue&type=style&index=0&id=fed53290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fed53290"]])

export default __exports__